import React, { useEffect, useRef, useState } from "react";
import { useFormik, Field, FormikProvider } from "formik";
import {
  parentPageFormstep1,
  parentPageFormstep2,
  parentPageFormstep3,
  parentPageFormstep4,
} from "../../schemas/formSchemas";
import ReCAPTCHA from "react-google-recaptcha";
import BreadCrumbs from "../../reuseable/BreadCrumbs";
import axios from "axios";
import SkeletonLoader from "../../reuseable/SkeletonLoader";
import { toast } from "react-toastify";
import SmartPhoneInput from "../../reuseable/SmartPhoneInput";
import EmailInput from "../../reuseable/EmailInput";
import { handlePhoneChange } from "../../../utils/phoneUtils";

const apiUrl = process.env.REACT_APP_API_URL_NAME;

const schoolPolicyContent1 = [
  {
    li: "Science Labs",
  },
  {
    li: "Sports (Indoor and Outdoor)",
  },
  {
    li: "Extra Curricular Activities",
  },
  {
    li: "Special Education Support",
  },
  {
    li: "Library",
  },
  {
    li: "Playgrounds",
  },
  {
    li: "Cafeteria",
  },
  {
    li: "Resource Room",
  },
  {
    li: "Art Room",
  },
  {
    li: "Auditorium",
  },
  {
    li: "Counselling Support",
  },
  {
    li: "First Aid Support",
  },
];

const schoolPolicyContent2 = [
  {
    li: "Experiential Learning",
  },
  {
    li: "Differentiated Learning",
  },
  {
    li: "Multiple Intelligence",
  },
  {
    li: "Learning Style",
  },
  {
    li: "Universal Design for Learning",
  },
  {
    li: "Social Emotional Curriculum",
  },
];

const schoolPolicyContent3 = [
  {
    li: "Child Protection Policy",
  },
  {
    li: "Health & Safety",
  },
  {
    li: "RTE Act 2009",
  },
  {
    li: "Barrier Free Environment (Accessibility)",
  },
  {
    li: "Grievance Redressal Committee",
  },
];

const schoolDetailsContent1 = [
  {
    li: "Primary",
  },
  {
    li: "HS",
  },
  {
    li: "IE",
  },
];

const schoolDetailsContent2 = [
  {
    li: "Primary",
  },
  {
    li: "Secondary",
  },
  {
    li: "Higher Secondary",
  },
];

const validationSchemas = {
  1: parentPageFormstep1,
  2: parentPageFormstep2,
  3: parentPageFormstep3,
};

const SchoolForm = () => {
  const formRef = useRef();
  const [optionSelected, setOptionSelected] = useState(false);

  const [step, setStep] = useState(1);
  const [recaptchaValue, setRecaptchaValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const formik = useFormik({
    initialValues: {
      schoolName: "",
      principalName: "",
      buildingName: "",
      buildingAddress: "",
      buildingState: "",
      buildingContact: "",
      yearEstablishment: "",
      administrationContact: "",
      phoneNumber: "",
      telephoneNumber: "",
      email: "",
      studentPopulation: "",
      teacherPopulation: "",
      captcha: "",
      schoolType: [],
      studentTeacherRatio: [],
      infrastructureFacility: [],
      curriculamSupport: [],
      schoolPolicy: [],
      inclusionPolicy: "",
      multidisciplinaryTeam: "",
      multidisciplinaryTeamDes: "",
    },

    // validationSchema: parentPageForm,
    validationSchema: validationSchemas[step],
    onSubmit: async (values, actions) => {
      // Handle form submission logic here
      setLoading(true);
      setSubmissionStatus(null);
      const schoolDB = {
        react_web: true,
        school_name: values.schoolName,
        school_principal_name: values.principalName,
        status: "null",
        school_building_name: values.buildingName,
        school_builiding_address: values.buildingAddress,
        school_district: values.buildingState,
        building_contract: values.buildingContact,
        admin_contract: values.administrationContact,
        phone_number: values.phoneNumber,
        telephone_number: values.telephoneNumber,
        school_email: values.email,
        year_of_establishment: values.yearEstablishment,
        totalstudent_population: values.studentPopulation,
        totalteacher_population: values.teacherPopulation,
        infra_facility: values.infrastructureFacility,
        school_curriculam: values.curriculamSupport,
        school_policy: values.schoolPolicy,
        school_type: values.schoolType,
        school_teacher_ratio: values.studentTeacherRatio,
        // have_exclusion_policy: values.policy,
        have_exclusion_policy: values.inclusionPolicy,
        // multidisciplinary_team: values.multidisciplinary,
        multidisciplinary_team: values.multidisciplinaryTeam,
        multidisciplinary_team_desc: values.multidisciplinaryTeamDes,
        "g-recaptcha-response": recaptchaValue,
      };

      try {
        // isSubmitting(true);
        const response = await axios.post(
          // "https://onlineappointment.onrender.com/schoolForm",
          // "http://183.83.188.205:60162/api/schoolenrollment/storedata",
          `${apiUrl}/schoolenrollment/storedata`,

          schoolDB
        );

        setSubmissionStatus("success");
        actions.resetForm();
      } catch (error) {
        if (error.response.data.code === 400) {
          setSubmissionStatus("emailerr");
        } else setSubmissionStatus("error");

        // alert("Form not submitted ");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleRecaptcha = (value) => {
    setRecaptchaValue(value);
    formik.setFieldValue("captcha", value);
  };

  const handleNumericInput = (e, field) => {
    const value = e.target.value.replace(/\D/g, "");
    formik.setFieldValue(field, value);
  };

  const handleNext = async () => {
    formRef.current.scrollIntoView({ behavior: "smooth" });

    formik.setTouched({
      schoolName: step === 1,
      principalName: step === 1,
      buildingName: step === 1,
      buildingAddress: step === 1,
      buildingState: step === 1,
      yearEstablishment: step === 1,
      buildingContact: step === 1,
      administrationContact: step === 1,
      phoneNumber: step === 1,
      telephoneNumber: step === 1,
      email: step === 1,
      studentPopulation: step === 1,
      teacherPopulation: step === 1,
      schoolType: step === 1,
      studentTeacherRatio: step === 1,

      infrastructureFacility: step === 2,
      curriculamSupport: step === 2,
      schoolPolicy: step === 2,
      multidisciplinaryTeam: step === 3,
      multidisciplinaryTeamDes: step === 3,
      inclusionPolicy: step === 3,
      // Add other fields
    });

    const errors = await formik.validateForm();

    if (!Object.keys(errors).length) {
      setStep(step + 1);
    } else {
    }
  };

  // Function to determine which fields to validate based on the current step

  const handlePrevious = () => {
    formRef.current.scrollIntoView({ behavior: "smooth" });

    setStep((prevStep) => prevStep - 1);
  };

  const handleCheckboxChange = (event, fieldName) => {
    const { value, checked } = event.target;
    const currentValues = formik.values[fieldName];
    if (checked) {
      formik.setFieldValue(fieldName, [...currentValues, value]);
    } else {
      formik.setFieldValue(
        fieldName,
        currentValues.filter((item) => item !== value)
      );
    }
  };

  useEffect(() => {
    if (submissionStatus === "success") {
      toast.success("School form has been submitted successfully!", {
        position: "top-center",
        className: "text-white",
      });
    } else if (submissionStatus === "emailerr") {
      toast.error(
        "The provided email address has already been registered. Please log in using this email or register with a different email address.",
        {
          position: "top-center",
          className: "text-red-500 bg-white",
        }
      );
    } else if (submissionStatus === "error") {
      toast.error(
        "There was an error submitting the form. Please contact admin.",
        {
          position: "top-center",
          className: "text-red-500 bg-white",
        }
      );
    }
  }, [submissionStatus]);

  return (
    <>
      <div ref={formRef} className="md:ml-14 md:pt-5">
        <BreadCrumbs />
      </div>
      <div class="flex items-center justify-center py-10 md:px-5 lg:p-12">
        <div class="mx-auto w-full max-w-[90%] md:max-w-[100%] lg:max-w-[80%] bg-gray-200 rounded-3xl p-10">
          <FormikProvider value={formik}>
            <form
              onSubmit={(e) => {
                formik.handleSubmit(e);
                formRef.current.scrollIntoView({ behavior: "smooth" });
              }}
            >
              {step === 1 && (
                <div className="step1">
                  <h1 className="text-center font-black text-4xl md:text-5xl text-blue-950 pb-8 ">
                    School Details
                  </h1>
                  <div class="mb-5 pt-3">
                    <div class="-mx-3 flex flex-wrap">
                      <div class="px-3 w-full md:w-[33.3%]">
                        <div class="mb-5">
                          <label class="mb-3 block text-base font-medium text-[#07074D]">
                            School Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id="schoolName"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.schoolName}
                            placeholder="Enter School Name"
                            class={`${formik.errors.schoolName &&
                              formik.touched.schoolName
                              ? "border border-red-600"
                              : " "
                              } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                          />
                          {formik.errors.schoolName &&
                            formik.touched.schoolName && (
                              <p className="text-sm font-semibold text-red-500">
                                {formik.errors.schoolName}
                              </p>
                            )}
                        </div>
                      </div>
                      <div class="px-3 w-full md:w-[33.3%]">
                        <label class="mb-3 block text-base font-medium text-[#07074D]">
                          Principal Name <span className="text-red-500">*</span>
                        </label>
                        <div class="mb-5">
                          <input
                            type="text"
                            id="principalName"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.principalName}
                            placeholder="Enter Principal Name"
                            class={`${formik.errors.principalName &&
                              formik.touched.principalName
                              ? "border border-red-600"
                              : ""
                              } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                          />
                          {formik.errors.principalName &&
                            formik.touched.principalName ? (
                            <p className="text-sm font-semibold text-red-500">
                              {formik.errors.principalName}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div class="px-3 w-full md:w-[33.3%]">
                        <label
                          for="name"
                          class="mb-3 block text-base font-medium text-[#07074D]"
                        >
                          Year of Establishment{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="tel"
                          id="yearEstablishment"
                          onChange={(e) => handleNumericInput(e, "yearEstablishment")}
                          value={formik.values.yearEstablishment}
                          onBlur={formik.handleBlur}
                          placeholder="Enter Year of Establishment"
                          className={`${formik.errors.yearEstablishment &&
                            formik.touched.yearEstablishment
                            ? "border border-red-600"
                            : ""
                            } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                        />
                        {formik.errors.yearEstablishment &&
                          formik.touched.yearEstablishment ? (
                          <p className="text-sm font-semibold text-red-500">
                            {formik.errors.yearEstablishment}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="mb-5 pt-3">
                    <div class="-mx-3 flex flex-wrap">
                      <div className="px-3 w-full md:w-[33.3%]">
                        <div class="mb-5">
                          <label
                            for="name"
                            class="mb-3 block text-base font-medium text-[#07074D]"
                          >
                            Building Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id="buildingName"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.buildingName}
                            placeholder="Enter Building Name"
                            class={`${formik.errors.buildingName &&
                              formik.touched.buildingName
                              ? "border border-red-600"
                              : ""
                              } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                          />
                          {formik.errors.buildingName &&
                            formik.touched.buildingName ? (
                            <p className="text-sm font-semibold text-red-500">
                              {formik.errors.buildingName}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="px-3 w-full md:w-[33.3%]">
                        <div class="mb-5">
                          <label
                            for="phone"
                            class="mb-3 block text-base font-medium text-[#07074D]"
                          >
                            Building Address{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id="buildingAddress"
                            onChange={formik.handleChange}
                            value={formik.values.buildingAddress}
                            onBlur={formik.handleBlur}
                            placeholder="Enter Your Building Address"
                            class={`${formik.errors.buildingAddress &&
                              formik.touched.buildingAddress
                              ? "border border-red-600"
                              : ""
                              } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                          />
                          {formik.errors.buildingAddress &&
                            formik.touched.buildingAddress ? (
                            <p className="text-sm font-semibold text-red-500">
                              {formik.errors.buildingAddress}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div class="px-3 w-full md:w-[33.3%]">
                        <label
                          for="name"
                          class="mb-3 block text-base font-medium text-[#07074D]"
                        >
                          Building State <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="buildingState"
                          onChange={formik.handleChange}
                          value={formik.values.buildingState}
                          onBlur={formik.handleBlur}
                          placeholder="Enter Building State"
                          class={`${formik.errors.buildingState &&
                            formik.touched.buildingState
                            ? "border border-red-600"
                            : ""
                            } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                        />
                        {formik.errors.buildingState &&
                          formik.touched.buildingState ? (
                          <p className="text-sm font-semibold text-red-500">
                            {formik.errors.buildingState}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="mb-5 pt-3">
                    <div class="-mx-3 flex flex-wrap">
                      <div class="px-3 w-full md:w-[33.3%]">
                        <div class="mb-5">
                          <label class="mb-3 block text-base font-medium text-[#07074D]">
                            Building Contact{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="tel"
                            id="buildingContact"
                            onBlur={formik.handleBlur}
                            onChange={(e) => handleNumericInput(e, "buildingContact")}
                            value={formik.values.buildingContact}
                            placeholder="Enter Building Contact"
                            class={`${formik.errors.buildingContact &&
                              formik.touched.buildingContact
                              ? "border border-red-600"
                              : " "
                              } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                          />
                          {formik.errors.buildingContact &&
                            formik.touched.buildingContact && (
                              <p className="text-sm font-semibold text-red-500">
                                {formik.errors.buildingContact}
                              </p>
                            )}
                        </div>
                      </div>
                      <div class="px-3 w-full md:w-[33.3%]">
                        <label class="mb-3 block text-base font-medium text-[#07074D]">
                          Administration Contact{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div class="mb-5">
                          <input
                            type="tel"
                            id="administrationContact"
                            onChange={(e) => handleNumericInput(e, "administrationContact")}
                            onBlur={formik.handleBlur}
                            value={formik.values.administrationContact}
                            placeholder="Enter Administration Contact"
                            class={`${formik.errors.administrationContact &&
                              formik.touched.administrationContact
                              ? "border border-red-600"
                              : ""
                              } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                          />
                          {formik.errors.administrationContact &&
                            formik.touched.administrationContact ? (
                            <p className="text-sm font-semibold text-red-500">
                              {formik.errors.administrationContact}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div class="px-3 w-full md:w-[33.3%]">
                        <div class="mb-5">
                          <label class="mb-3 block text-base font-medium text-[#07074D]">
                            Phone Number <span className="text-red-500">*</span>
                          </label>
                          {/* <input
                          type="tel"
                          id="phoneNumber"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.phoneNumber}
                          placeholder="Enter Phone Number"
                          class={`${
                            formik.errors.phoneNumber &&
                            formik.touched.phoneNumber
                              ? "border border-red-600"
                              : " "
                          } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                        />
                        {formik.errors.phoneNumber &&
                          formik.touched.phoneNumber && (
                            <p className="text-sm font-semibold text-red-500">
                              {formik.errors.phoneNumber}
                            </p>
                          )} */}
                          <Field
                            name="phoneNumber"
                            component={SmartPhoneInput}
                            placeholder="Phone Number"
                            onChange={(phone, country, e, formattedValue) => handlePhoneChange(phone, country, e, formattedValue, formik, "phoneNumber")}
                          />


                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mb-5">
                    <div class="-mx-3 flex flex-wrap">
                      <div class="px-3 w-full md:w-1/2">
                        <label class="mb-3 block text-base font-medium text-[#07074D]">
                          Telephone Number <span className="text-red-500">*</span>
                        </label>
                        <div class="mb-5">
                          <Field
                            name="telephoneNumber"
                            component={SmartPhoneInput}
                            placeholder="Telephone Number"
                            onChange={(phone, country, e, formattedValue) => handlePhoneChange(phone, country, e, formattedValue, formik, "telephoneNumber")}
                          />
                        </div>
                      </div>
                      <div class="px-3 w-full md:w-1/2">
                        <label
                          for="email"
                          class="mb-3 block text-base font-medium text-[#07074D]"
                        >
                          Email Address <span className="text-red-500">*</span>
                        </label>
                        <Field
                          name="email"
                          component={EmailInput}
                          placeholder="Enter Your Email Address"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="mb-5">
                    <div class="-mx-3 flex flex-wrap">
                      <div class="px-3 w-full md:w-1/2">
                        <label class="mb-3 block text-base font-medium text-[#07074D]">
                          Total Number of Student Population{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div class="mb-5">
                          <input
                            type="tel"
                            id="studentPopulation"
                            onChange={(e) => handleNumericInput(e, "studentPopulation")}
                            onBlur={formik.handleBlur}
                            value={formik.values.studentPopulation}
                            placeholder="Total Number of Student Population"
                            className={`${formik.errors.studentPopulation &&
                              formik.touched.studentPopulation
                              ? "border border-red-600"
                              : ""
                              } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                          />
                          {formik.errors.studentPopulation &&
                            formik.touched.studentPopulation ? (
                            <p className="text-sm font-semibold text-red-500">
                              {formik.errors.studentPopulation}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div class="px-3 w-full md:w-1/2">
                        <label
                          for="email"
                          class="mb-3 block text-base font-medium text-[#07074D]"
                        >
                          Total Number of Teacher Population{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="tel"
                          id="teacherPopulation"
                          onChange={(e) => handleNumericInput(e, "teacherPopulation")}
                          onBlur={formik.handleBlur}
                          value={formik.values.teacherPopulation}
                          placeholder="Total Number of Teacher Population"
                          className={`${formik.errors.teacherPopulation &&
                            formik.touched.teacherPopulation
                            ? "border border-red-600"
                            : ""
                            } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                        />
                        {formik.errors.teacherPopulation &&
                          formik.touched.teacherPopulation ? (
                          <p className="text-sm font-semibold text-red-500">
                            {formik.errors.teacherPopulation}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>

                  <div class="mb-5">
                    <div class="-mx-3 flex flex-wrap">
                      <div class="px-3 w-full md:w-1/2">
                        <label class="mb-5 block text-lg font-black text-[#07074D] ">
                          School Type <span className="text-red-500">*</span>
                        </label>
                        <div class="w-full px-3 mb-5  grid grid-cols-1 lg:grid-cols-3 ">
                          {schoolDetailsContent1.map((item) => (
                            <div className="flex items-center gap-3">
                              <input
                                type="checkbox"
                                className="rounded-[25%]    "
                                id="schoolType"
                                onBlur={formik.handleBlur}
                                // onChange={formik.handleChange}
                                // value={formik.values.schoolType}
                                value={item.li}
                                onChange={(event) =>
                                  handleCheckboxChange(event, "schoolType")
                                }
                                checked={formik.values.schoolType.includes(
                                  item.li
                                )}
                                class={`${formik.errors.schoolType &&
                                  formik.touched.schoolType
                                  ? "border border-red-600"
                                  : " "
                                  }   bg-white  text-base font-medium text-green-600 outline-none focus:border-[#6A64F1] focus:shadow-md`}
                              />
                              <label class="block text-base font-medium text-[#07074D]">
                                {item.li}
                              </label>
                            </div>
                          ))}
                          {formik.errors.schoolType &&
                            formik.touched.schoolType ? (
                            <p className="text-sm font-semibold text-red-500">
                              {formik.errors.schoolType}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div class="px-3 w-full md:w-1/2">
                        <label class="mb-5 block text-lg font-black text-[#07074D] ">
                          Student Teacher Ratio{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div class="w-full px-3 mb-5  grid grid-cols-1 lg:grid-cols-3 ">
                          {schoolDetailsContent2.map((item) => (
                            <div className="flex items-center gap-3">
                              <input
                                type="checkbox"
                                className="rounded-[25%] "
                                id="studentTeacherRatio"
                                onBlur={formik.handleBlur}
                                // onChange={formik.handleChange}
                                // value={formik.values.studentTeacherRatio}
                                value={item.li}
                                onChange={(event) =>
                                  handleCheckboxChange(
                                    event,
                                    "studentTeacherRatio"
                                  )
                                }
                                checked={formik.values.studentTeacherRatio.includes(
                                  item.li
                                )}
                                class={`${formik.errors.studentTeacherRatio &&
                                  formik.touched.studentTeacherRatio
                                  ? "border border-red-600"
                                  : " "
                                  }   bg-white  text-base font-medium text-green-600 outline-none focus:border-[#6A64F1] focus:shadow-md`}
                              />
                              <label class="block text-base font-medium text-[#07074D]">
                                {item.li}
                              </label>
                            </div>
                          ))}
                          {formik.errors.studentTeacherRatio &&
                            formik.touched.studentTeacherRatio ? (
                            <p className="text-sm font-semibold text-red-500">
                              {formik.errors.studentTeacherRatio}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {step === 2 && (
                <div className="step2">
                  <>
                    <h1 className="text-center font-black text-3xl md:text-4xl text-blue-950 pb-8">
                      General Questions
                    </h1>
                    <div class="mb-5 pt-3 flex flex-col gap-3 ">
                      <>
                        <label class="mb-5 block text-lg md:text-xl font-black text-[#07074D] ">
                          1. Infrastructure Facility{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div class="w-full px-3 mb-5  grid grid-cols-1 md:grid-cols-3 ">
                          {schoolPolicyContent1.map((item) => (
                            <div className="flex items-center gap-3">
                              <input
                                type="checkbox"
                                className="rounded-[25%]  "
                                id="infrastructureFacility"
                                onBlur={formik.handleBlur}
                                // onChange={formik.handleChange}
                                // value={formik.values.infrastructureFacility}
                                value={item.li}
                                onChange={(event) =>
                                  handleCheckboxChange(
                                    event,
                                    "infrastructureFacility"
                                  )
                                }
                                checked={formik.values.infrastructureFacility.includes(
                                  item.li
                                )}
                                class={`${formik.errors.infrastructureFacility &&
                                  formik.touched.infrastructureFacility
                                  ? "border border-red-600"
                                  : " "
                                  }   bg-white  text-base font-medium text-green-600 outline-none focus:border-[#6A64F1] focus:shadow-md`}
                              />
                              <label class="block text-base md:text-lg font-medium text-[#07074D]">
                                {item.li}
                              </label>
                            </div>
                          ))}
                          {formik.errors.infrastructureFacility &&
                            formik.touched.infrastructureFacility ? (
                            <p className="text-sm font-semibold text-red-500">
                              {formik.errors.infrastructureFacility}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                      <>
                        <label class="mb-5 block text-lg md:text-xl font-black text-[#07074D] ">
                          2. Is the School Curriculum Supportive of These
                          Educational Components
                          <span className="text-red-500">*</span>
                        </label>
                        <div class="w-full px-3 mb-5  grid grid-cols-1 md:grid-cols-3 ">
                          {schoolPolicyContent2.map((item) => (
                            <div className="flex items-center gap-3">
                              <input
                                type="checkbox"
                                className="rounded-[25%]  "
                                id="curriculamSupport"
                                onBlur={formik.handleBlur}
                                // onChange={formik.handleChange}
                                // value={formik.values.curriculamSupport}
                                value={item.li}
                                onChange={(event) =>
                                  handleCheckboxChange(event, "curriculamSupport")
                                }
                                checked={formik.values.curriculamSupport.includes(
                                  item.li
                                )}
                                placeholder="Child name"
                                class={`${formik.errors.curriculamSupport &&
                                  formik.touched.curriculamSupport
                                  ? "border border-red-600"
                                  : " "
                                  }   bg-white  text-base font-medium text-green-600 outline-none focus:border-[#6A64F1] focus:shadow-md`}
                              />
                              <label class="block text-base md:text-lg font-medium text-[#07074D]">
                                {item.li}
                              </label>
                            </div>
                          ))}
                          {formik.errors.curriculamSupport &&
                            formik.touched.curriculamSupport ? (
                            <p className="text-sm font-semibold text-red-500">
                              {formik.errors.curriculamSupport}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                      <>
                        <label class="mb-5 block text-lg md:text-xl font-black text-[#07074D] ">
                          3. Has Your School Implemented the Policies
                          <span className="text-red-500">*</span>
                        </label>
                        <div class="w-full px-3 grid grid-cols-1 md:grid-cols-2 ">
                          {schoolPolicyContent3.map((item) => (
                            <div className="flex w-full items-center gap-3">
                              <input
                                type="checkbox"
                                className="rounded-[25%]  "
                                id="schoolPolicy"
                                onBlur={formik.handleBlur}
                                // onChange={formik.handleChange}
                                // value={formik.values.schoolPolicy}
                                value={item.li}
                                onChange={(event) =>
                                  handleCheckboxChange(event, "schoolPolicy")
                                }
                                checked={formik.values.schoolPolicy.includes(
                                  item.li
                                )}
                                class={`${formik.errors.schoolPolicy &&
                                  formik.touched.schoolPolicy
                                  ? "border border-red-600"
                                  : " "
                                  }   bg-white  text-base font-medium text-green-600 outline-none focus:border-[#6A64F1] focus:shadow-md`}
                              />
                              <label class="w-full block text-base md:text-lg font-medium text-[#161660]">
                                {item.li}
                              </label>
                            </div>
                          ))}
                        </div>
                        {formik.errors.schoolPolicy &&
                          formik.touched.schoolPolicy ? (
                          <p className="text-sm font-semibold text-red-500">
                            {formik.errors.schoolPolicy}
                          </p>
                        ) : (
                          ""
                        )}
                      </>
                    </div>
                  </>
                </div>
              )}

              {loading ? (
                <>
                  <SkeletonLoader itemCount={3} />{" "}
                </>
              ) : (
                <>
                  {step === 3 && (
                    <div className="step3">
                      <div className="">
                        <h1 className="text-center font-black text-4xl text-blue-950 pb-8">
                          School Policy
                        </h1>
                        <div className="flex flex-col gap-5 mb-10">
                          <div className="mb-5">
                            <h1 className="font-bold text-lg md:text-xl mb-5">
                              1. Does the school have an inclusion policy that
                              specifies action for including children with special
                              needs?<span className="text-red-500">*</span>
                            </h1>
                            <div className="flex gap-5 items-center">
                              <div className="flex items-center gap-3">
                                <input
                                  type="radio"
                                  id="inclusionPolicyYes"
                                  name="inclusionPolicy"
                                  value="Yes"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  checked={
                                    formik.values.inclusionPolicy === "Yes"
                                  }
                                  className="form-radio h-5 w-5 text-blue-600"
                                />
                                <label htmlFor="inclusionPolicyYes">Yes</label>
                              </div>
                              <div className="flex items-center gap-3">
                                <input
                                  type="radio"
                                  id="inclusionPolicyNo"
                                  name="inclusionPolicy"
                                  value="No"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  checked={formik.values.inclusionPolicy === "No"}
                                  className="form-radio h-5 w-5 text-blue-600"
                                />
                                <label htmlFor="inclusionPolicyNo">No</label>
                              </div>
                              {formik.errors.inclusionPolicy &&
                                formik.touched.inclusionPolicy ? (
                                <p className="text-sm font-semibold text-red-500">
                                  {formik.errors.inclusionPolicy}
                                </p>
                              ) : null}
                            </div>
                          </div>

                          <div className="mb-5">
                            <h1 className="font-bold text-lg md:text-xl mb-5">
                              2. Is a multidisciplinary team approach in your
                              school to provide alternatives to suspension or
                              expulsion for students with complex needs?
                              <span className="text-red-500">*</span>
                            </h1>
                            <div className="flex gap-5 items-center">
                              <div className="flex items-center gap-3">
                                <input
                                  type="radio"
                                  id="multidisciplinaryTeamYes"
                                  name="multidisciplinaryTeam"
                                  value="Yes"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setOptionSelected(true);
                                  }}
                                  onBlur={formik.handleBlur}
                                  checked={
                                    formik.values.multidisciplinaryTeam === "Yes"
                                  }
                                  className="form-radio h-5 w-5 text-blue-600"
                                />
                                <label htmlFor="multidisciplinaryTeamYes">
                                  Yes
                                </label>
                              </div>
                              <div className="flex items-center gap-3">
                                <input
                                  type="radio"
                                  id="multidisciplinaryTeamNo"
                                  name="multidisciplinaryTeam"
                                  value="No"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setOptionSelected(false);
                                  }}
                                  onBlur={formik.handleBlur}
                                  checked={
                                    formik.values.multidisciplinaryTeam === "No"
                                  }
                                  className="form-radio h-5 w-5 text-blue-600"
                                />
                                <label htmlFor="multidisciplinaryTeamNo">
                                  No
                                </label>
                              </div>
                              {formik.errors.multidisciplinaryTeam &&
                                formik.touched.multidisciplinaryTeam ? (
                                <p className="text-sm font-semibold text-red-500">
                                  {formik.errors.multidisciplinaryTeam}
                                </p>
                              ) : null}
                            </div>
                          </div>

                          <div className="mb-5">
                            {optionSelected && (
                              <div class="w-full md:w-[100%]">
                                <label
                                  for="name"
                                  class="font-bold text-lg md:text-xl mb-5 "
                                >
                                  3. Is There a Shared Framework for Goals and
                                  Outcomes of Multidisciplinary Teams Work in Your
                                  School: <span className="text-red-500">*</span>
                                </label>
                                <textarea
                                  type="text"
                                  id="multidisciplinaryTeamDes"
                                  name="multidisciplinaryTeamDes"
                                  onChange={formik.handleChange}
                                  value={formik.values.multidisciplinaryTeamDes}
                                  onBlur={formik.handleBlur}
                                  placeholder=""
                                  class={`${formik.errors.multidisciplinaryTeamDes &&
                                    formik.touched.multidisciplinaryTeamDes
                                    ? "border border-red-600"
                                    : ""
                                    } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                                />
                                {formik.errors.multidisciplinaryTeamDes &&
                                  formik.touched.multidisciplinaryTeamDes ? (
                                  <p className="text-sm font-semibold text-red-500">
                                    {formik.errors.multidisciplinaryTeamDes}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {step === 3 && (
                    <div id="captcha" className="pb-5">
                      <ReCAPTCHA
                        onChange={handleRecaptcha}
                        // sitekey="6LceNQYqAAAAANmxHgRcfdU_e8KW_c05MKTOBai3"
                        sitekey="6LcfLFUoAAAAACno3hdClnckkDsl4ERrkfhX7Alr"
                      />
                      {formik.errors.captcha && formik.touched.captcha ? (
                        <p className="text-sm font-semibold text-red-500">
                          {formik.errors.captcha}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </>
              )}

              <div className="flex justify-between">
                {step > 1 && (
                  <button
                    type="button"
                    onClick={handlePrevious}
                    className="hover:shadow-form w-[30%] rounded-md border-blue-950 hover:border-blue-950 hover:text-blue-950 bg-blue-950 py-3 md:px-8 text-center text-base font-semibold text-white outline-none"
                  >
                    Previous
                  </button>
                )}
                {step < 3 && (
                  <button
                    type="button"
                    onClick={handleNext}
                    className={`${step === 2 || step === 3 ? "justify-between" : "justify-end"
                      }  hover:shadow-form w-[30%] rounded-md border-blue-950 hover:border-blue-950 hover:text-blue-950 bg-blue-950 py-3 md:px-8 text-center text-base font-semibold text-white outline-none`}
                  >
                    Next
                  </button>
                )}
                {step === 3 && (
                  <button
                    type="submit"
                    disabled={loading}
                    className="hover:shadow-form w-[40%] rounded-md bg-blue-950 border-blue-950 hover:border-blue-950 hover:text-blue-950 py-3 md:px-8 text-center text-base font-semibold text-white outline-none"
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                )}
              </div>
              {/* {submissionStatus === "success" && (
              <div className="mt-5 text-green-500 text-center">
                Form submitted successfully!
              </div>
            )}
            {submissionStatus === "error" && (
              <div className="mt-5 text-red-500 text-center">
                There was an error submitting the form. Please contact admin.
              </div>
            )} */}
            </form>
          </FormikProvider>
        </div>
      </div>
    </>
  );
};

export default SchoolForm;
